import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { LegalizarEscritura } from './LegalizarEscrituras.component';


import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'LegalizarEscritura',
        component: LegalizarEscritura,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'LegalizarEscritura',
          nombreFormulario : 'LegalizarEscritura'
        } 
    }
];

@NgModule({
    declarations: [
        LegalizarEscritura
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        LegalizarEscritura    ]
})

export class LegalizarEscriturasModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/LegalizacionEscrituras/LegalizarEscrituras.module.ts